import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasLongDuration'
})
export class HasLongDuration implements PipeTransform {

  transform(start: Date, end: Date, hours: number = 2): boolean {
    const diffHours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
    return diffHours > hours;
  }

}
